// extracted by mini-css-extract-plugin
module.exports = {"container":"CautionCodeBlock_container__QdS1_","codeBlock":"CautionCodeBlock_codeBlock__sYghH","content":"CautionCodeBlock_content__xHbBq"};